import { FaGithub, FaLinkedin, FaTwitter, FaFacebook } from 'react-icons/fa';

const Footer = ({ profile }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <span className="navbar-logo">Portfolio</span>
          <div className="footer-social">
            {profile?.social?.github && (
              <a href={profile.social.github} target="_blank" rel="noreferrer"><FaGithub /></a>
            )}
            {profile?.social?.linkedin && (
              <a href={profile.social.linkedin} target="_blank" rel="noreferrer"><FaLinkedin /></a>
            )}
            {profile?.social?.twitter && (
              <a href={profile.social.twitter} target="_blank" rel="noreferrer"><FaTwitter /></a>
            )}
            {profile?.social?.facebook && (
              <a href={profile.social.facebook} target="_blank" rel="noreferrer"><FaFacebook /></a>
            )}
          </div>
        </div>
        <p>&copy; {new Date().getFullYear()} {profile?.name || 'Portfolio'}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
